import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { WebStorageService, LOCAL_STORAGE } from "ngx-webstorage-service";
import { DomSanitizer } from "@angular/platform-browser";
import { AddAddendumUpcomingComponent } from "../add-addendum-upcoming/add-addendum-upcoming.component";
import { AddendumService } from "../services/addendum.service";
import { StandardService } from "../services/standard.service";
import { CryptographyService } from "../services/cryptography.service";

@Component({
  selector: "app-update-addendum",
  templateUrl: "../add-addendum-upcoming/add-addendum-upcoming.component.html",
  styleUrls: ["../add-addendum-upcoming/add-addendum-upcoming.component.scss"],
})
export class UpdateAddEndumComponent
  extends AddAddendumUpcomingComponent
  implements OnInit
{
  override isEditMode = true;
  override pageTitle = "Update Exception";

  constructor(
    addendumService: AddendumService,
    standardService: StandardService,
    cryptographyService: CryptographyService,
    router: Router,
    @Inject(LOCAL_STORAGE) storage: WebStorageService,
    activeRoute: ActivatedRoute,
    fb: FormBuilder,
    ngbModal: NgbModal,
    sanitizer: DomSanitizer
  ) {
    super(
      addendumService,
      standardService,
      cryptographyService,
      router,
      storage,
      activeRoute,
      fb,
      ngbModal,
      sanitizer
    );
  }

  override ngOnInit(): void {
    this.loading = true;
    this.userRole = this.cryptographyService.decryptData(
      this.storage.get("userRole")
    );
    this.createForm();
    this.getMasterDataForNrbes();

    const addendumId = parseInt(
      this.activeRoute.snapshot.paramMap.get("standardId")
    );
    this.loadExistingAddendum(addendumId);
  }
}
